import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4479c9a2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "container-title" }
const _hoisted_2 = { class: "features" }
const _hoisted_3 = { class: "feature-description" }
const _hoisted_4 = { class: "mt-4" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "videos" }
const _hoisted_7 = { class: "videos-buttons" }
const _hoisted_8 = {
  id: "video",
  autoplay: "",
  muted: "",
  loop: "",
  playsinline: ""
}
const _hoisted_9 = ["src"]

import { computed, onMounted, onUnmounted, ref, watch } from "vue"
import { useI18n } from "vue-i18n"
interface Feature {
  title: string
  subtitle: string
  text: string
  video: string
  videoLength: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'FeatureVideos',
  setup(__props) {

const { t } = useI18n()

const features = ref<Feature[]>([
  {
    title: t("feature-video.student.title"),
    subtitle: t("feature-video.student.subtitle"),
    text: t("feature-video.student.text"),
    video: "student",
    videoLength: 74,
  },
  {
    title: t("feature-video.doctor.title"),
    subtitle: t("feature-video.doctor.subtitle"),
    text: t("feature-video.doctor.text"),
    video: "doctor",
    videoLength: 80,
  },
  {
    title: t("feature-video.hospital.title"),
    subtitle: t("feature-video.hospital.subtitle"),
    text: t("feature-video.hospital.text"),
    video: "hospital",
    videoLength: 84,
  },
])

const activeTimeout = ref<number>()
const selectedFeatureIndex = ref(0)

const selectedFeature = computed((): Feature => {
  return features.value[selectedFeatureIndex.value]
})

onMounted(() => {
  onSelectedFeatureChanged()
  localeChanged()
  window.addEventListener("locale-changed", localeChanged)
})
onUnmounted(() => {
  window.removeEventListener("locale-changed", localeChanged)
})

const localeChanged = () => {
  features.value = [
    {
      title: t("feature-video.student.title"),
      subtitle: t("feature-video.student.subtitle"),
      text: t("feature-video.student.text"),
      video: "student",
      videoLength: 74,
    },
    {
      title: t("feature-video.doctor.title"),
      subtitle: t("feature-video.doctor.subtitle"),
      text: t("feature-video.doctor.text"),
      video: "doctor",
      videoLength: 80,
    },
    {
      title: t("feature-video.hospital.title"),
      subtitle: t("feature-video.hospital.subtitle"),
      text: t("feature-video.hospital.text"),
      video: "hospital",
      videoLength: 84,
    },
  ]
}

watch(selectedFeatureIndex, () => {
  onSelectedFeatureChanged()
})

const onSelectedFeatureChanged = (): void => {
  var video = document.getElementById("video") as any
  video.load()
  video.play()
  video.playbackRate = 1.5

  clearTimeout(activeTimeout.value)
  activeTimeout.value = setTimeout(() => {
    selectedFeatureIndex.value =
      (selectedFeatureIndex.value + 1) % features.value.length
  }, (selectedFeature.value.videoLength * 1000) / 1.5)
}

return (_ctx: any,_cache: any) => {
  const _component_v_btn = _resolveComponent("v-btn")!

  return (_openBlock(), _createElementBlock("div", {
    class: "feature-videos-container",
    key: features.value.length
  }, [
    _createElementVNode("h1", _hoisted_1, _toDisplayString(_ctx.$t("feature-video.title")), 1),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("h4", null, _toDisplayString(selectedFeature.value.title), 1),
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("p", {
            innerHTML: selectedFeature.value.text
          }, null, 8, _hoisted_5)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(features.value, (feature, index) => {
            return (_openBlock(), _createBlock(_component_v_btn, {
              color: selectedFeature.value === feature ? '#3fb984' : undefined,
              text: selectedFeature.value !== feature,
              key: index,
              variant: "text",
              small: "",
              onClick: ($event: any) => (selectedFeatureIndex.value = index)
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(feature.title), 1)
              ]),
              _: 2
            }, 1032, ["color", "text", "onClick"]))
          }), 128))
        ]),
        _createElementVNode("video", _hoisted_8, [
          _createElementVNode("source", {
            src: 
              require('../../../assets/videos/' +
                selectedFeature.value.video +
                '.mp4')
            ,
            type: "video/mp4"
          }, null, 8, _hoisted_9)
        ])
      ])
    ])
  ]))
}
}

})